<template>
    <div class="container block-hl">

        <template v-for="(item, index) in [ data[3] ] " :key="index">
            <div v-if="'list' in item" class="card">
                <div class="row">
                    <div class="col content">
                        <div class="__header">
                            <div class="__h2">
                                <h2>{{ item.title }}</h2>
                            </div>
                            <div v-if="item.icon" class="__icon">
                                <img :src="item.icon">
                            </div>
                        </div>
                        <ul>
                            <li class="plus" v-for="(item2, index2) in item.list" :key="index2">
                                <div class="__container">
                                    <div class="__title"><b>{{ item2[0] }}</b></div>
                                    <TransitionGroup name="desc">
                                        <template v-if="!item2[2]">
                                            <div class="__description" v-if="item.show">{{ item2[1] }}</div>
                                        </template>
                                    </TransitionGroup>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="item.icon" class="col icon">
                        <div class="icon">
                            <img :src="item.icon">
                        </div>
                    </div>
                </div>
                <div v-if="item.collapse" :id="'block-hl-button-'+index" class="__control">
                    <button v-if="!item.show"
                        @click="() => { handleClickShow(item) }"
                        :class="{ '__hide': item.show }"
                        >{{ item.show ? 'Скрыть' : 'Подробнее' }}
                    </button>
                </div>
            </div>
        </template>

        <template v-if="true">
            <div class="card">
                <div class="row">
                    <div class="col content">
                        <div class="__header">
                            <div class="__h2">
                                <h2>Что вас ждёт?</h2>
                            </div>
                            <div class="__icon">
                                <img :src="chvzh.icon">
                            </div>
                        </div>
                        <ul>
                            <li class="plus">
                                <div class="__container">
                                    <div class="__title">
                                        <b>Решение проблем в привлечении пациентов</b>
                                    </div>
                                    <TransitionGroup name="desc">
                                        <div class="__description" v-if="chvzh.show">
                                            — узнайте, как устранить основные препятствия на пути к притоку первичных пациентов. Конкретные стратегии и работающие методики, которые позволят наладить стабильный поток без лишних затрат и стрессов.
                                            <p>
                                                Если Вы врач или руководитель; занимаетесь продвижением, но не получаете нужного результата, чувствуете, что не хватает понимания, то наше мероприятие - это то, что Вам нужно.
                                            </p>
                                        </div>
                                    </TransitionGroup>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="chvzh.icon" class="col icon">
                        <div class="icon">
                            <img :src="chvzh.icon">
                        </div>
                    </div>
                </div>
                <div v-if="chvzh.collapse" :id="'block-hl-button-'+ 1223" class="__control">
                    <button v-if="!chvzh.show"
                        @click="() => { handleClickShow(chvzh) }"
                        :class="{ '__hide': chvzh.show }"
                        >{{ chvzh.show ? 'Скрыть' : 'Подробнее' }}
                    </button>
                </div>
            </div>
        </template>

        <!-- <template v-for="(item, index) in data" :key="index">
            <div v-if="'list' in item" class="card">
                <div class="row">
                    <div class="col content">
                        <div class="__header">
                            <div class="__h2">
                                <H2>{{ item.title }}</H2>
                            </div>
                            <div v-if="item.icon" class="__icon">
                                <img :src="item.icon">
                            </div>
                        </div>
                        <ul>
                            <li class="plus" v-for="(item2, index2) in item.list" :key="index2">
                                <div class="__container">
                                    <div class="__title"><b>{{ item2[0] }}</b></div>
                                    <TransitionGroup name="desc">
                                        <template v-if="!item2[2]">
                                            <div class="__description" v-if="item.show">{{ item2[1] }}</div>
                                        </template>
                                    </TransitionGroup>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="item.icon" class="col icon">
                        <div class="icon">
                            <img :src="item.icon">
                        </div>
                    </div>
                </div>
                <div v-if="item.collapse" :id="'block-hl-button-'+index" class="__control">
                    <button v-if="!item.show"
                        @click="() => { handleClickShow(item) }"
                        :class="{ '__hide': item.show }"
                        >{{ item.show ? 'Скрыть' : 'Подробнее' }}
                    </button>
                </div>
            </div>
        </template> -->
        <template v-for="(item, index) in [data[2]]" :key="index">
            <div v-if="'list' in item" class="card">
                <div class="row">
                    <div class="col content">
                        <div class="__header">
                            <div class="__h2">
                                <h2>{{ item.title }}</h2>
                            </div>
                            <div v-if="item.icon" class="__icon">
                                <img :src="item.icon">
                            </div>
                        </div>
                        <ul>
                            <li class="plus" v-for="(item2, index2) in item.list" :key="index2">
                                <div class="__container">
                                    <div class="__title"><b>{{ item2[0] }}</b></div>
                                    <TransitionGroup name="desc">
                                        <template v-if="!item2[2]">
                                            <div class="__description" v-if="item.show">{{ item2[1] }}</div>
                                        </template>
                                    </TransitionGroup>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="item.icon" class="col icon">
                        <div class="icon">
                            <img :src="item.icon">
                        </div>
                    </div>
                </div>
                <div v-if="item.collapse" :id="'block-hl-button-'+index" class="__control">
                    <button v-if="!item.show"
                        @click="() => { handleClickShow(item) }"
                        :class="{ '__hide': item.show }"
                        >{{ item.show ? 'Скрыть' : 'Подробнее' }}
                    </button>
                </div>
            </div>
        </template>
        <template v-for="(item, index) in [data[4]]" :key="index">
            <div v-if="'list' in item" class="card">
                <div class="row">
                    <div class="col content">
                        <div class="__header">
                            <div class="__h2">
                                <h2>{{ item.title }}</h2>
                            </div>
                            <div v-if="item.icon" class="__icon">
                                <img :src="item.icon">
                            </div>
                        </div>
                        <ul>
                            <li class="plus" v-for="(item2, index2) in item.list" :key="index2">
                                <div class="__container">
                                    <div class="__title"><b>{{ item2[0] }}</b></div>
                                    <TransitionGroup name="desc">
                                        <template v-if="!item2[2]">
                                            <div class="__description" v-if="item.show">{{ item2[1] }}</div>
                                        </template>
                                    </TransitionGroup>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="item.icon" class="col icon">
                        <div class="icon">
                            <img :src="item.icon">
                        </div>
                    </div>
                </div>
                <div v-if="item.collapse" :id="'block-hl-button-'+index" class="__control">
                    <button v-if="!item.show"
                        @click="() => { handleClickShow(item) }"
                        :class="{ '__hide': item.show }"
                        >{{ item.show ? 'Скрыть' : 'Подробнее' }}
                    </button>
                </div>
            </div>
        </template>
        <template v-for="(item, index) in [data[5]]" :key="index">
            <div v-if="'list' in item" class="card">
                <div class="row">
                    <div class="col content">
                        <div class="__header">
                            <div class="__h2">
                                <h2>{{ item.title }}</h2>
                            </div>
                            <div v-if="item.icon" class="__icon">
                                <img :src="item.icon">
                            </div>
                        </div>
                        <ul>
                            <li class="plus" v-for="(item2, index2) in item.list" :key="index2">
                                <div class="__container">
                                    <div class="__title"><b>{{ item2[0] }}</b></div>
                                    <TransitionGroup name="desc">
                                        <template v-if="!item2[2]">
                                            <div class="__description" v-if="item.show">{{ item2[1] }}</div>
                                        </template>
                                    </TransitionGroup>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="item.icon" class="col icon">
                        <div class="icon">
                            <img :src="item.icon">
                        </div>
                    </div>
                </div>
                <div v-if="item.collapse" :id="'block-hl-button-'+index" class="__control">
                    <button v-if="!item.show"
                        @click="() => { handleClickShow(item) }"
                        :class="{ '__hide': item.show }"
                        >{{ item.show ? 'Скрыть' : 'Подробнее' }}
                    </button>
                </div>
            </div>
        </template>
        
        <div class="__infopath">
            <div class="__img">
                <img :src="infopath" alt="">
            </div>
        </div>

        <template v-if="true">
            <div class="card">
                <div class="row">
                    <div class="col content">
                        <div class="__header">
                            <div class="__h2">
                                <h2>Нетворкинг</h2>
                            </div>
                            <div class="__icon">
                                <img :src="ntwg.icon">
                            </div>
                        </div>
                        <ul>
                            <li class="plus">
                                <div class="__container">
                                    <div class="__title">
                                        <b>У Вас будет уникальная возможность пообщаться с докладчиками лично и задать им интересующие вопросы.</b>
                                    </div>
                                    <TransitionGroup name="desc">
                                        <div class="__description" v-if="ntwg.show">
                                            Узнайте больше о представленных стратегиях, уточните детали для внедрения в Ваш бренд врача, Вашу клинику и получите советы, основанные на реальном опыте экспертов.
                                            В атмосфере понимания и поддержки, Вас выслушают и протянут руку помощи.
                                            Если у Вас остаются вопросы, нет четкой понятной картины, что делать, то после конференции Вы можете получить бесплатную консультацию экспертов.
                                            <p>
                                                <b>Эксперты:</b>
                                                <ul>
                                                    <li>Оценят текущее положение дел и выявят ошибки;</li>
                                                    <li>Внимательно выслушают Ваши проблемы и помогут определить Вашу готовность к изменениям в продвижении;</li>
                                                    <li>Вместе мы разработаем стратегию продвижения врача и клиники под Ваши запросы.</li>
                                                </ul>
                                            </p>
                                        </div>
                                    </TransitionGroup>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="ntwg.icon" class="col icon">
                        <div class="icon">
                            <img :src="ntwg.icon">
                        </div>
                    </div>
                </div>
                <div v-if="ntwg.collapse" :id="'block-hl-button-'+ 1234" class="__control">
                    <button v-if="!ntwg.show"
                        @click="() => { handleClickShow(ntwg) }"
                        :class="{ '__hide': ntwg.show }"
                        >{{ ntwg.show ? 'Скрыть' : 'Подробнее' }}
                    </button>
                </div>
            </div>
        </template>

        
    </div>
</template>
<script>
import listeners from '@/lib/listeners'
import icon05 from '@/assets/05.svg'
import icon04 from '@/assets/04.svg'
import infopath from '@/assets/infopath.png'

export default {
    name: 'WhoListeners',
    components: {

    },
    props: {},
    data() {
        return {
            data: listeners,
            show: false,
            chvzh: {
                icon: icon05,
                show: false,
                collapse: true,
            },
            ntwg: {
                icon: icon04,
                show: false,
                collapse: true,
            },
            infopath,
        }
    },
    mounted() {
    },
    methods: {
        handleClickShow: function(item) {
            item.show = !item.show
        },
    }
}
</script>
<style lang="scss">
$primary: #1E9BD8;
$text-color: #FCF9F9;
.row{
    .col{
        &.content{
            flex-grow: 1;
        }
        &.icon{
            @media ( max-width: 992px ) {
                display: none;
            }
            width: auto;
        }
    }
}
.block-hl{
    margin-top: 1em;
    .card{
        transition: all 1s;
        // background-image: radial-gradient( circle at 90% 35%, #1E9BD8 -20%, transparent 26% ), radial-gradient( circle at 105% 43%, #290A4F -10%, transparent 23%);
        background-image: radial-gradient(circle at 121% 24%, #1E9BD8 0%, transparent 41%), radial-gradient(circle at -47% 118%, #1d0d8e 5%, transparent 53%);
        @media ( min-width: 992px ) {
            background-image: radial-gradient(circle at 100% -105%, #1E9BD8 -5%, transparent 42%), radial-gradient(circle at 23% 142%, #1d0d8e -5%, transparent 38%);
        }
        padding: 20px 20px 20px 20px !important;
        h2{
            padding-left: 0px;
            margin: 0;
        }
        ul{
            padding: 0 0 0 20px;
            color: $text-color;
        }
        background-color: transparent;
        // background-image: none;
        border: solid 1px rgba(83, 83, 83, 1);
        // border: solid 1px #fff;
        padding-bottom: 40px;
    }
    .__header{
        display: flex;
        align-items: center;
        .__h2{
            flex-grow: 1;
            font-size:.65em;
            @media ( min-width: 376px ) {
                font-size: 1em;
            }
        }
        .__icon{
            @media ( min-width: 992px ) {
                display: none;
            }
            img{
                height: 50px;
                width: 50px;
                @media ( min-width: 768px ) {
                    height: 60px;
                    width: 60px;
                }
            }
        }
    }
    .icon{
        width: 80px;
        height: 80px;
        padding-left: 5px;
        img{
            width: 100%;
            height: auto;
        }
    }
    .__control{
        text-align: end;
    }
    button{
        background: $primary;
        border: solid 1px $primary;
        border-radius: 24px;
        height: 42px;
        padding: 10px 24px;
        color: #fff;
        font-size: 1em;
        // &.__hide{
        //     background: #1d0d8e;
        // }
    }
    .__container{
        // display: inline-block;
        display: flow-root;
        position: relative;
        // flex-direction: column;
    }
    .__title{
        line-height: 1.5;
        float: left;
    }
    .__description{
        white-space: pre-wrap;
        line-height: 1.5;
        transition: all 0.2s ease;
    }

    .__infopath{
        // object-fit: contain;
        margin-bottom: 1em;
        .__img{
            @media ( min-width: 992px ) {
                overflow: hidden;
                height: 450px;
            }
            img{
                object-fit: contain;
                width: 100%;
                height: 100%;
            }
        }
    }
}
// .span-enter-active{
//     transition: font-size .2s ease-out;
// }
// .span-leave-active {
//   transition: font-size .2s ease-in;
// }
// .span-enter-from{
//     font-size: 0em;
//     opacity: 0;
//     // margin-top: -100px;  
// }
// .span-enter-to{
//     font-size: 1em;
//     opacity: 1;
//     // margin-top: -100px;  
// }
// .span-leave-from {
//     // opacity: 0;
//     font-size: 1em;
//     opacity: 1;
// }
// .span-leave-to {
//     // opacity: 0;
//     opacity: 0;
//     font-size: 0em;
// }
// .desc-enter-active {}
.desc-leave-active {
    position: absolute;
    // transition: all 2s ease;
}
.desc-enter-from,
.desc-leave-to {
    opacity: 0;
    transform: translateY(-30px);
    // height: 0px;
    // opacity: 0;
}
.desc-move{
    transition: transform .2s ease;
}
</style>